import styled from '@emotion/styled';

export const EmprtyChartContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;
	padding-bottom: 3rem;

	${({ dashedBackground }) =>
		dashedBackground &&
		`
        background-image: linear-gradient(to right, var(--white) 5px, transparent 1px),
		linear-gradient(var(--border-color) 1px, transparent 1px);
        background-size: 10px 57px;
        background-position: 0 36px;
    `};
`;
